export default __webpack_public_path__ + "static/media/BK_97_QT_Header_3.b400c381.png";